<template>
  <list :list="list"
        :infiniteId="infiniteId"
        :headers="headers"
        :loading="loading"
        @load="load">
    <template slot="default"
              slot-scope="slotProps">
      <voucher-segment-client-list-item-code v-if="isVoucherType"
                                             :item="slotProps.item"
                                             @reload="emitReload"
                                             @deleted="emitReload" />
      <voucher-segment-client-list-item-login v-else
                                              :item="slotProps.item"
                                              @reload="emitReload"
                                              @deleted="emitReload" />
    </template>
  </list>
</template>

<script>
import List from "@components/generic/list/List.vue";
import VoucherSegmentClientListItemCode from "@components/modules/voucher/segment/client/list/item/code/VoucherSegmentClientListItemCode.vue";
import VoucherSegmentClientListItemLogin from "@components/modules/voucher/segment/client/list/item/login/VoucherSegmentClientListItemLogin.vue";

export default {
  components: {
    List,
    VoucherSegmentClientListItemCode,
    VoucherSegmentClientListItemLogin,
  },

  data() {
    return {
      loading: false,
      list: [],
    };
  },

  mixins: [],

  props: {
    infiniteId: {
      type: Number,
      required: true,
    },
    segment: {
      type: Object,
      required: true,
    },
    search: {
      type: String,
      required: false,
    },
    page: {
      type: Number,
    }
  },

  watch: {
    search() {
      this.list = [];
      this.load();
    },
    page(val) {
      if(val === 0) this.list = []
    }
  },

  methods: {
    async load($state) {
      try {
        const response = await this.$api.core.voucher.client.list({
          segmentId: this.segment.id,
          search: this.search,
          page: this.page
        });
        
        if (response.length !== 0) {
          this.list.push(...response)
          $state.loaded();
          this.$emit('increment-page')

          if (response.length < 100) {
            $state.complete();
          }
        } else {
          this.list = response
          $state.complete();
        }        
      } catch (error) {
        console.log(error);
      } 
    },
    emitReload() {
      this.list = []
      this.$emit("reload");
    },
  },

  computed: {
    isVoucherType() {
      return this.segment.type === "VOUCHER_CODE";
    },
    headers() {
      return this.isVoucherType
        ? [
            { text: "Voucher", value: "code", sortable: false },
            { text: "Usos restante", value: "quantity", sortable: false },
            { text: "Data de expiração", value: "expirationDate", sortable: false },
            {
              text: "Comentário",
              value: "comment",
              sortable: false,
            },
          ]
        : [
            { text: "Login", value: "login", sortable: false },
            { text: "Senha", value: "password", sortable: false },
            {
              text: "Usos restantes",
              value: "useCounter",
              sortable: false,
            },
            { text: "Data de expiração", value: "expirationDate", sortable: false },
            {
              text: "Comentário",
              value: "comment",
              sortable: false,
            },
          ];
    },
  },
};
</script>

<style lang="scss" scoped>
</style>